import { timetable_item_insert_input, update_timetable_itemMutationVariables } from '@app-types/graphql-types';
import { FormatTimelineItemsArgs } from '@modules/timetable';
import { TimelineItemTypeType } from '@app-types/timetable';

export const formatTimelineItems = ({
  timelineItems,
  startOfWeek,
  endOfWeek,
  classIds,
  publish,
  userId: createUserId,
}: FormatTimelineItemsArgs): [timetable_item_insert_input[], update_timetable_itemMutationVariables[]] => {
  const newTimelineItems: timetable_item_insert_input[] = [];
  const existingTimelineItems: update_timetable_itemMutationVariables[] = [];

  timelineItems.forEach((timelineItem) => {
    if (
      (timelineItem.itemType === TimelineItemTypeType.subject ||
        timelineItem.itemType === TimelineItemTypeType.extra) &&
      classIds.includes(timelineItem.batchClassID.split('/')[1]) &&
      timelineItem.startTime >= startOfWeek &&
      timelineItem.endTime <= endOfWeek
    ) {
      if (timelineItem.dbId) {
        existingTimelineItems.push({
          where: {
            id: {
              _eq: timelineItem.dbId,
            },
          },
          _set: {
            startTime: timelineItem.startTime,
            endTime: timelineItem.endTime,
            locationId: timelineItem.locationID,
            userId: timelineItem.lecturerID,
            published: publish,
            createUserId,
          },
        });
      } else {
        newTimelineItems.push({
          startTime: timelineItem.startTime,
          endTime: timelineItem.endTime,
          batchSubjectConfigurationId:
            timelineItem.itemType === TimelineItemTypeType.subject ? timelineItem.elementID : null,
          batchSubjectExtraSlotId: timelineItem.itemType === TimelineItemTypeType.extra ? timelineItem.elementID : null,
          locationId: timelineItem.locationID,
          userId: timelineItem.lecturerID,
          batchClassId: timelineItem.batchClassID.split('/')[1],
          published: publish,
          createUserId,
        });
      }
    }
  });

  return [newTimelineItems, existingTimelineItems];
};
